export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      icon: 'ri-mail-line',
      title: 'お問い合わせ',
      description: 'まずはお気軽にお問い合わせください。お電話、メール、公式LINEからご連絡いただけます。'
    },
    {
      number: '02',
      icon: 'ri-discuss-line',
      title: 'ヒアリング',
      description: 'お客様のご要望や課題を丁寧にお伺いし、最適なソリューションをご提案いたします。'
    },
    {
      number: '03',
      icon: 'ri-file-list-3-line',
      title: 'お見積り',
      description: 'ヒアリング内容を基に、詳細なお見積りを作成してご提示いたします。'
    },
    {
      number: '04',
      icon: 'ri-pencil-ruler-2-line',
      title: '制作開始',
      description: 'ご契約後、制作を開始いたします。進捗状況は随時ご報告させていただきます。'
    },
    {
      number: '05',
      icon: 'ri-eye-line',
      title: '確認・修正',
      description: '制作物をご確認いただき、修正が必要な箇所があれば対応いたします。'
    },
    {
      number: '06',
      icon: 'ri-checkbox-circle-line',
      title: '納品',
      description: '最終確認後、納品いたします。アフターサポートもお任せください。'
    }
  ];

  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2C2C2C]">
            ご依頼の流れ
          </h2>
          <p className="text-base sm:text-lg text-[#757575] max-w-3xl mx-auto leading-relaxed">
            お問い合わせから納品まで、安心してお任せいただける流れをご用意しています
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative bg-gradient-to-br from-[#FAF0E6] to-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:scale-105"
            >
              <div className="absolute -top-4 -left-4 w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#66BB6A] to-[#4CAF50] rounded-2xl shadow-lg">
                <span className="text-2xl font-bold text-white">{step.number}</span>
              </div>

              <div className="mt-6 space-y-4">
                <div className="w-14 h-14 flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className={`${step.icon} text-3xl text-[#66BB6A]`}></i>
                </div>

                <h3 className="text-2xl font-bold text-[#2C2C2C]">
                  {step.title}
                </h3>

                <p className="text-base text-[#757575] leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#66BB6A] to-[#4CAF50] text-white px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-send-line text-xl"></i>
            まずはお問い合わせください
          </a>
        </div>
      </div>
    </section>
  );
}
